import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraKeyValueRow } from '../lieutenants/key-value-row';
import { SpecraSectionHeader } from '../lieutenants/section-header';
function RecordRailSection({ getRowTestId, getSectionProps, getSectionTestId, section }) {
    const headingId = React.useId();
    return /*#__PURE__*/ _jsxs("section", {
        ...getSectionProps?.(section),
        "aria-labelledby": headingId,
        "data-item-id": section.id,
        "data-testid": getSectionTestId?.(section),
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                action: section.action,
                className: "border-b-0 pb-[var(--space-1)]",
                headingAs: "h2",
                headingId: headingId,
                title: section.title,
                variant: "group"
            }),
            section.facts?.map((fact)=>/*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    "data-item-id": fact.id,
                    "data-testid": getRowTestId?.(section, fact.id),
                    dense: true,
                    label: fact.label,
                    value: fact.value,
                    variant: "fact"
                }, fact.id)),
            section.rows?.map((row)=>/*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    "data-item-id": row.id,
                    "data-testid": getRowTestId?.(section, row.id),
                    dense: true,
                    label: row.label,
                    value: row.value ?? null,
                    variant: "default"
                }, row.id)),
            section.children != null ? /*#__PURE__*/ _jsx("div", {
                className: "mt-[var(--space-2)] flex flex-col gap-[var(--space-2)]",
                children: section.children
            }) : null
        ]
    });
}
/**
 * Record page right rail: several titled sections of facts, entity rows and
 * free composition. Not a landmark itself; the admiral's rail column
 * (`SpecraDashboardPage railVariant="record"`) is the complementary region.
 */ export const SpecraRecordRail = /*#__PURE__*/ React.forwardRef(({ className, getRowTestId, getSectionProps, getSectionTestId, sections, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        className: cn('flex flex-col gap-[var(--space-6)] px-[var(--space-6)] pt-[var(--space-6)] pb-[var(--space-8)]', className),
        ref: ref,
        ...props,
        children: sections.map((section)=>/*#__PURE__*/ _jsx(RecordRailSection, {
                getRowTestId: getRowTestId,
                getSectionProps: getSectionProps,
                getSectionTestId: getSectionTestId,
                section: section
            }, section.id))
    }));
SpecraRecordRail.displayName = 'SpecraRecordRail';
